module.exports = __webpack_public_path__ + "img/distress-signal.eec2e0b4.jpg";